// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/chat/v1/vision_chat_message.proto (package protos.vision.chat.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/chat/v1/vision_chat_message.proto.
 */
export const file_vision_chat_v1_vision_chat_message: GenFile = /*@__PURE__*/
  fileDesc("Cih2aXNpb24vY2hhdC92MS92aXNpb25fY2hhdF9tZXNzYWdlLnByb3RvEhVwcm90b3MudmlzaW9uLmNoYXQudjEi7gMKEVZpc2lvbkNoYXRNZXNzYWdlEhIKCm1lc3NhZ2VfaWQYASABKAkSEgoKcHJvamVjdF9pZBgCIAEoCRIQCghpbWFnZV9pZBgDIAEoCRIZChFhdXRob3JfYWNjb3VudF9pZBgEIAEoCRITCgthdXRob3JfbmFtZRgFIAEoCRJCCgxtZXNzYWdlX3R5cGUYBiABKA4yLC5wcm90b3MudmlzaW9uLmNoYXQudjEuVmlzaW9uQ2hhdE1lc3NhZ2VUeXBlEkEKBHRleHQYByABKAsyMS5wcm90b3MudmlzaW9uLmNoYXQudjEuVmlzaW9uQ2hhdE1lc3NhZ2UuVGV4dERhdGFIABJHCghyZXBseV90bxgIIAEoCzI1LnByb3Rvcy52aXNpb24uY2hhdC52MS5WaXNpb25DaGF0TWVzc2FnZS5SZXBseVByZXZpZXcSLgoKY3JlYXRlZF9hdBgJIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAaGAoIVGV4dERhdGESDAoEdGV4dBgBIAEoCRpNCgxSZXBseVByZXZpZXcSEgoKbWVzc2FnZV9pZBgBIAEoCRITCgthdXRob3JfbmFtZRgCIAEoCRIUCgx0ZXh0X3ByZXZpZXcYAyABKAlCBgoEZGF0YSpgChVWaXNpb25DaGF0TWVzc2FnZVR5cGUSJAogVklTSU9OX0NIQVRfTUVTU0FHRV9UWVBFX1VOS05PV04QABIhCh1WSVNJT05fQ0hBVF9NRVNTQUdFX1RZUEVfVEVYVBABYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * @generated from message protos.vision.chat.v1.VisionChatMessage
 */
export type VisionChatMessage = Message<"protos.vision.chat.v1.VisionChatMessage"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 3;
   */
  imageId: string;

  /**
   * @generated from field: string author_account_id = 4;
   */
  authorAccountId: string;

  /**
   * @generated from field: string author_name = 5;
   */
  authorName: string;

  /**
   * @generated from field: protos.vision.chat.v1.VisionChatMessageType message_type = 6;
   */
  messageType: VisionChatMessageType;

  /**
   * @generated from oneof protos.vision.chat.v1.VisionChatMessage.data
   */
  data: {
    /**
     * @generated from field: protos.vision.chat.v1.VisionChatMessage.TextData text = 7;
     */
    value: VisionChatMessage_TextData;
    case: "text";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: protos.vision.chat.v1.VisionChatMessage.ReplyPreview reply_to = 8;
   */
  replyTo?: VisionChatMessage_ReplyPreview | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.chat.v1.VisionChatMessage.
 * Use `create(VisionChatMessageSchema)` to create a new message.
 */
export const VisionChatMessageSchema: GenMessage<VisionChatMessage> = /*@__PURE__*/
  messageDesc(file_vision_chat_v1_vision_chat_message, 0);

/**
 * @generated from message protos.vision.chat.v1.VisionChatMessage.TextData
 */
export type VisionChatMessage_TextData = Message<"protos.vision.chat.v1.VisionChatMessage.TextData"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message protos.vision.chat.v1.VisionChatMessage.TextData.
 * Use `create(VisionChatMessage_TextDataSchema)` to create a new message.
 */
export const VisionChatMessage_TextDataSchema: GenMessage<VisionChatMessage_TextData> = /*@__PURE__*/
  messageDesc(file_vision_chat_v1_vision_chat_message, 0, 0);

/**
 * @generated from message protos.vision.chat.v1.VisionChatMessage.ReplyPreview
 */
export type VisionChatMessage_ReplyPreview = Message<"protos.vision.chat.v1.VisionChatMessage.ReplyPreview"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: string author_name = 2;
   */
  authorName: string;

  /**
   * @generated from field: string text_preview = 3;
   */
  textPreview: string;
};

/**
 * Describes the message protos.vision.chat.v1.VisionChatMessage.ReplyPreview.
 * Use `create(VisionChatMessage_ReplyPreviewSchema)` to create a new message.
 */
export const VisionChatMessage_ReplyPreviewSchema: GenMessage<VisionChatMessage_ReplyPreview> = /*@__PURE__*/
  messageDesc(file_vision_chat_v1_vision_chat_message, 0, 1);

/**
 * @generated from enum protos.vision.chat.v1.VisionChatMessageType
 */
export enum VisionChatMessageType {
  /**
   * @generated from enum value: VISION_CHAT_MESSAGE_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: VISION_CHAT_MESSAGE_TYPE_TEXT = 1;
   */
  TEXT = 1,
}

/**
 * Describes the enum protos.vision.chat.v1.VisionChatMessageType.
 */
export const VisionChatMessageTypeSchema: GenEnum<VisionChatMessageType> = /*@__PURE__*/
  enumDesc(file_vision_chat_v1_vision_chat_message, 0);

